import React from 'react';
import { useParams, matchPath } from 'react-router';
import { Breadcrumbs, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import get from 'lodash/get';
import { Home as HomeIcon } from '@mui/icons-material';
import routes from '../../../routes';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';

const RenderDashboardBreadcrumb = ({ eventId, isMobileView }) => (
  <div>
    {isMobileView ? (
      <Breadcrumbs aria-label="Breadcrumbs">
        <StyledRescuerBreadcrumb
          component={Link}
          to={routes.index}
          label="Home"
          icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
        />
        <StyledRescuerTextBreadcrumb component="a" href="#" label={eventId} />
      </Breadcrumbs>
    ) : (
      <Breadcrumbs aria-label="Breadcrumbs">
        <Link color="inherit" to={routes.index}>
          Dashboard
        </Link>

        <Typography color="textPrimary">{eventId}</Typography>
      </Breadcrumbs>
    )}
  </div>
);

const EventDetailsBreadcrumb = ({ isMobileView }) => {
  const { eventId } = useParams();
  const location = useLocation();

  if (!get(location, 'state.prevPath')) {
    return <RenderDashboardBreadcrumb eventId={eventId} isMobileView={isMobileView} />;
  }

  const {
    state: { prevPath },
  } = location;

  let origin = matchPath(prevPath, {
    path: routes.eventsList,
    exact: true,
  })
    ? 'Events'
    : undefined;

  origin = matchPath(prevPath, {
    path: routes.rescuesSchedule,
    exact: true,
  })
    ? 'Schedule'
    : origin;

  origin = matchPath(prevPath, {
    path: routes.mobileDashboardSchedule,
    exact: true,
  })
    ? 'Schedule'
    : origin;

  origin =
    matchPath(prevPath, {
      path: routes.dashboardRescuer,
      exact: true,
    }) ||
    matchPath(prevPath, {
      path: routes.dashboardSC,
      exact: true,
    })
      ? 'Dashboard'
      : origin;

  if (!origin) {
    return <RenderDashboardBreadcrumb eventId={eventId} isMobileView={isMobileView} />;
  }

  return (
    <div>
      {isMobileView ? (
        <Breadcrumbs aria-label="Breadcrumbs">
          <StyledRescuerBreadcrumb
            component={Link}
            to={routes.index}
            label="Home"
            icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
          />
          <StyledRescuerTextBreadcrumb
            component={Link}
            to={{ pathname: prevPath, state: location.state }}
            label={origin}
          />
          <StyledRescuerTextBreadcrumb label={eventId} />
        </Breadcrumbs>
      ) : (
        <Breadcrumbs aria-label="Breadcrumbs">
          <Link color="inherit" to={{ pathname: prevPath, state: location.state }}>
            {origin}
          </Link>

          <Typography color="textPrimary">{eventId}</Typography>
        </Breadcrumbs>
      )}
    </div>
  );
};

export default EventDetailsBreadcrumb;
